import {
  MoreHorizontal,
  Download,
  Save,
  ListFilter,
  BarChart2,
  LineChart,
  PieChart,
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { VisualizationType, QueryResultData } from '../../types/analytics.types';
import { getAllowedVisualizations, VISUALIZATION_LABELS } from '../../lib/visualizationSelector';

interface CardMenuProps {
  resultType: QueryResultData['type'];
  currentVisualization: VisualizationType;
  onChangeVisualization: (type: VisualizationType) => void;
  onViewList: () => void;
  onSaveToDashboard: () => void;
  onExport: () => void;
}

const VISUALIZATION_ICONS: Record<VisualizationType, React.ReactNode> = {
  big_number: <span className="text-lg font-bold">#</span>,
  horizontal_bar: <BarChart2 className="h-4 w-4 rotate-90" />,
  vertical_bar: <BarChart2 className="h-4 w-4" />,
  line: <LineChart className="h-4 w-4" />,
  donut: <PieChart className="h-4 w-4" />,
  table: <ListFilter className="h-4 w-4" />,
};

export function CardMenu({
  resultType,
  currentVisualization,
  onChangeVisualization,
  onViewList,
  onSaveToDashboard,
  onExport,
}: CardMenuProps) {
  const allowedVisualizations = getAllowedVisualizations(resultType);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {allowedVisualizations.length > 1 && (
          <>
            <DropdownMenuSub>
              <DropdownMenuSubTrigger>
                <BarChart2 className="h-4 w-4 mr-2" />
                Chart Type
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent>
                {allowedVisualizations.map((vis) => (
                  <DropdownMenuItem
                    key={vis}
                    onClick={() => onChangeVisualization(vis)}
                    className={vis === currentVisualization ? 'bg-accent' : ''}
                  >
                    <span className="mr-2">{VISUALIZATION_ICONS[vis]}</span>
                    {VISUALIZATION_LABELS[vis]}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
            <DropdownMenuSeparator />
          </>
        )}

        <DropdownMenuItem onClick={onViewList}>
          <ListFilter className="h-4 w-4 mr-2" />
          View Patient List
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={onSaveToDashboard}>
          <Save className="h-4 w-4 mr-2" />
          Save to Dashboard
        </DropdownMenuItem>

        <DropdownMenuItem onClick={onExport}>
          <Download className="h-4 w-4 mr-2" />
          Export Data
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
